import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType } from 'vue';
import { BaseSelect } from '@/lib/components/Select';
import { IOption } from '@/lib';
import { FilterTag, Tag } from '@/models';
import { capitalize } from '@/lib/helpers/string.helper';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalTeamSelect',
  props: {
  hospitalTeam: {
    type: String as PropType<FilterTag['id']>,
    default: ''
  },
  hospitalTeams: {
    type: Array as PropType<FilterTag[]>,
    default: () => []
  },
  errors: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  dataDusk: {
    type: String,
    default: 'copd-program-hospital-team'
  }
},
  emits: ["update:hospital-team"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();
const validationErrors = computed<string | null>(() => props.errors || null);
const hospitalTeamLabel = computed<string>(() => capitalize(t('custom.uhb.copd.hospital-team')));
const hospitalTeamPlaceholder = computed<string>(() => capitalize(
  t(
    'custom.uhb.copd.select-entity',
    [(t('custom.uhb.copd.hospital-team')).toLowerCase()]
  )
));
const hospitalTeamOptions = computed<IOption[]>(() =>
  props.hospitalTeams?.map((team: FilterTag) => ({
    value: team.id,
    label: team.name
  }))
);

const updateHospitalTeam = (tagId: string) => {
  const tag = props.hospitalTeams?.find((tag) => tag.id === tagId);
  if (tag) {
    emit('update:hospital-team', {
      id: tag.id,
      title: tag.name,
      attributes: {
        name: tag.name
      }
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseSelect), {
    "data-dusk": __props.dataDusk,
    "model-value": __props.hospitalTeam,
    label: hospitalTeamLabel.value,
    placeholder: hospitalTeamPlaceholder.value,
    options: hospitalTeamOptions.value,
    error: validationErrors.value,
    disabled: __props.disabled,
    class: "w-full",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateHospitalTeam($event as string)))
  }, null, 8, ["data-dusk", "model-value", "label", "placeholder", "options", "error", "disabled"]))
}
}

})